import { browserHistory } from 'react-router'
import React, { Component } from 'react'
import FeeEditForm from "./editform.component.jsx"
import { FormattedMessage } from 'react-intl'
import SideBar from '../../common/layout/sidebar.component.jsx'
const queryString = require('query-string')
class FeeNew extends Component {

    constructor(props, context) {
        super(props, context);

        const uri = queryString.parse(this.props.location.search)
        this.state = {
            createType: uri.create_type || 'percentage-rate'
        }
    }

    componentDidMount() {
        SideBar.activateMenu('account')
    }

    renderHeaderLabel() {
        switch (this.state.createType) {
            case 'flat-rate':
                return <FormattedMessage
                    id="fee.form.new.shipping_title"
                    defaultMessage="Create Flat amount Fee"
                />
            case 'percentage-rate':
            default:
                return <FormattedMessage
                    id="fee.form.new.title"
                    defaultMessage="Create Percentage Fee"
                />
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 ui-title-bar">
                        <div className="row">
                            <div className="col-12">
                                <h2>
                                    {this.renderHeaderLabel()}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
                <FeeEditForm createType={this.state.createType} />
            </div>
        );
    }
}

export default FeeNew


// WEBPACK FOOTER //
// ./src/settings/fees/new.component.jsx